import { observer } from "mobx-react";

import CreateModal from "@component/CreateModal";
import Capacity from "@model/Capacity";
import CapacityCreateVM from "@vm/Create/Capacity";
import Form from "./Form";

import { lazyInject, TYPES } from "../../../../inversify.config";
import Button, { ButtonVariant } from "@eman/emankit/Button";
import React from "react";
import EventBus, { SHOW_TOAST } from "@util/EventBus";
import { confirmYesNo } from "@eman/emankit/ConfirmAlert";
import { UserRightsObjects, UserRightsOperations } from "@model/Rights";
import { computed } from "mobx";

@observer
export default class CapacityCreateModal extends CreateModal<Capacity> {
  modelName = "capacity";
  prefix = "employee";

  @lazyInject(TYPES.CapacityCreate)
  vm: CapacityCreateVM;

  componentDidMount(): void {
    const params = this.props.match.params;
    this.vm.workingTimeRatiosListVM.scroll = false;
    this.vm.workingTimeRatiosListVM.setId(params.user_id, params.contract_id);
    this.vm.setParentId(params.user_id);
    super.componentDidMount();
  }

  buttons() {
    return (
      <>
        <Button className="mr-12" onClick={this.onReset}>
          {this.locs.tg("form.reset")}
        </Button>
        <Button variant={ButtonVariant.Primary} onClick={this.onSave} disabled={!this.vm.allowedToSave}>
          {this.locs.tg("form.create")}
        </Button>
      </>
    );
  }

  @computed
  get canCreateBeforeToday(): boolean {
    return this.user.allowToObject(UserRightsObjects.TIME_LIMITS, UserRightsOperations.IGNORE_TODAYS_DEPENDENT_VALIDATIONS);
  }

  onSave = async () => {
    confirmYesNo(
      <>
        <p className="warning-message">{this.locs.tg("form.create_confirm_capacity.create_capacity")}</p>
        {this.locs.tg("form.create_confirm_capacity.begin")}
        <br />
        {this.locs.tg("form.create_confirm_capacity.end")}
      </>,
      async () => {
        const id = await this.vm.create();

        if (id) {
          EventBus.trigger(SHOW_TOAST, this.successMessage());
          this.onClose();
        }
      },
      { confirmButtonType: ButtonVariant.SecondaryBlue, cancelButtonType: ButtonVariant.Primary }
    );
    return "";
  };

  onClose = () => {
    const params = this.props.match.params;
    this.router.pageLink(this.uriHelper.show_employees_contracts(params.user_id, params.contract_id));
  };

  renderModalBody() {
    // Check #PPM-704 - there is an issue
    // - buttons() is not rendering (sometimes! that is the weirdest part)
    // - this void makes an observer for totalCapacity and it works like charm
    // @ts-ignore
    void this.vm.entity?.totalCapacity;

    return (
      <Form
        canCreateBeforeToday={this.canCreateBeforeToday}
        entity={this.vm.entity}
        vm={this.vm.capacityFormVM}
        allowedRatiosTitles={this.vm.workingTimeRatiosListVM.allowedRatiosTitlesCreate}
      />
    );
  }
}
